<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Отчёт</h2>

          <div class="px-3"></div>

          <v-menu offset-y bottom>
            <template v-slot:activator="{ on }">
              <v-text-field
                class="mx-4"
                label="старт"
                v-model="start"
                v-on="on"
                :disabled="inAction"
                style="max-width: 200px"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              :disabled="inAction" locale="ru" first-day-of-week="1"
              v-model="start" :landscape="true" :reactive="true"
            ></v-date-picker>
          </v-menu>

          <v-menu offset-y bottom>
            <template v-slot:activator="{ on }">
              <v-text-field
                class="mx-3"
                label="финиш"
                v-model="end"
                v-on="on"
                :disabled="inAction"
                style="max-width: 200px"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              :disabled="inAction" locale="ru" first-day-of-week="1"
              v-model="end" :landscape="true" :reactive="true"
            ></v-date-picker>
          </v-menu>

          <v-btn color="primary"
            @click="fetch()"
            :disabled="inAction"
          >
            <template v-if="inAction">
              {{this.dayInAction}} &nbsp;
              <v-progress-circular :size="15" indeterminate></v-progress-circular>
            </template>
            <span v-else>Посчитать</span>
          </v-btn>

          <v-dialog
            v-model="dialogList"
            scrollable fullscreen
            persistent :overlay="false"
            max-width="500px"
            transition="dialog-bottom-transition"
            ref="printReport"
          >
            <template v-slot:activator="{ on }">
              <v-btn
              fab small
              class="mx-3 elevation-0"
              hide-details
              v-on="on"
              :disabled="!report || inAction"
              >
                <v-icon color="secondary">view_list</v-icon>
              </v-btn>
            </template>
            <v-card flat tile>
              <v-card-actions primary-title class="pl-5 ml-3">
                <h3>Отчёт по агентам с {{start}} по {{end}}</h3>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  class="hide-on-print"
                  @click="print()"
                >
                  <v-icon color="secondary">print</v-icon>
                </v-btn>
                <v-btn
                  icon
                  class="hide-on-print"
                  @click="dialogList=false"
                >
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-actions>
              <v-card-text class="pt-0">
                <v-flex xs12 sm10 md6 lg4>
                  <ReportList id="printableArea" :report="report"></ReportList>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>

          <v-menu offset-y bottom :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn
                fab small
                class="mx-3 elevation-0"
                v-on="on"
                hide-details
                @click="fetchMessagesReport"
              ><v-icon color="secondary">message</v-icon></v-btn>
            </template>
            <v-card>
              <v-card-title>
                <small>Отчёт по сообщениям с {{start}} по {{end}}</small>
              </v-card-title>
              <v-card-text>
                <v-data-table
                :headers="[{text: 'транспорт', value: 'transport'},{text: 'тарифицированы?', value: 'tariffed'},{text: 'статус', value: 'status'},{text: 'количество', value: 'count'}]"
                :items="messagesReport"
                class="elevation-0"
                :items-per-page="-1"
                hide-default-footer
                >
                <template v-slot:item.tariffed="{ item }">
                  {{ item.tariffed === true ? 'да' : 'нет' }}
                </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-menu>

          <v-menu offset-y bottom :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn
                fab small
                class="mx-3 elevation-0"
                v-on="on"
                hide-details
                @click="fetchSubsReport"
              ><v-icon color="secondary">subscriptions</v-icon></v-btn>
            </template>
            <v-card>
              <v-card-title>
                <small>Отчёт по подпискам с {{start}} по {{end}}</small>
              </v-card-title>
              <v-card-text>
                <v-data-table
                :headers="[{text: 'транспорт', value: 'transport'},{text: 'сумма', value: 'amount'},{text: 'кол-во списаний', value: 'count', align: 'center'}]"
                :items="subsReport"
                class="elevation-0"
                :items-per-page="-1"
                hide-default-footer
                >
                <template v-slot:item.amount="{ item }">
                  {{ parseFloat(item.amount || 0).toFixed(2) }} руб.
                </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-menu>

        </v-toolbar>
      </v-flex>
      <v-flex xs12 v-if="report">
        <v-subheader>Всего платежей на сумму: &nbsp;<b>{{rubles(totalBanks)}} рублей</b></v-subheader>
      </v-flex>
      <v-flex xs3 v-for="org in reportOrdered" class="pa-2" v-if="report && !migrationHidden(org)">
        <v-sheet>
          <h4 class="pa-3 weight-500 darkligth">{{org.title}}</h4>
          <h5 class="pa-3">
            <span class="subtitle-2 weight-400">{{org.description}}</span><br />
            <div class="weight-300">
              {{org.details.inn}} {{org.details.address}}
            </div>
          </h5>
          <v-divider></v-divider>
          <v-list dense class="mx-0 px-0">
            <v-list-group
              v-model="activity.open"
              v-for="activity in org.activities"
              no-action
            >
              <template v-slot:activator>
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>{{activity.title}}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action class="subtitle-2">
                    <b v-if="activity.sum === 0" class="amount-0">{{rubles(activity.sum)}}</b>
                    <b v-else :class="activity.sum < 0 ? 'amount-minus' : 'amount-plus'">{{rubles(activity.sum)}}</b>
                  </v-list-item-action>
                </v-list-item>
              </template>
              <v-list-item v-for="purpose in activity.purposes" class="pl-5">
                <v-list-item-content>
                  <v-list-item-title><i class="weight-300">{{purpose.title}}</i></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="subtitle-2">
                  <template v-if="parseInt(purpose.sum) === 0">
                    <span>{{rubles(purpose.sum)}}</span>
                  </template>
                  <template v-else-if="parseInt(purpose.sum) > 0">
                    <span class="amount-plus">+{{rubles(purpose.sum || 0)}}</span>
                  </template>
                  <template v-else>
                    <span class="amount-minus">{{rubles(purpose.sum || 0)}}</span>
                  </template>
                </v-list-item-action>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-sheet>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import ReportList from '@/components/ReportList.vue'
import pako from 'pako'
import { Base64 } from 'js-base64'
async function asyncTimeout (ms) {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(), ms)
  })
}
export default {
  name: 'Finances',
  components: { ReportList },
  data: () => ({
    start: moment().startOf('month').format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD'),
    inAction: false,
    dayInAction: null,
    stopNext: false,
    reports: [],
    report: null,
    totalBanks: 0,
    dialogList: false,
    messagesReport: [],
    subsReport: [],
    printContents: '',
    reportLinkData: null,
  }),
  methods: {
    showorder (a, b) {
      try {
        return a.showorder - b.showorder
      } catch (e) {
        return 0
      }
    },
    print () {
      this.printContents = document.getElementById('printableArea').innerHTML
      this.reportLinkData = Base64.encode(
        pako.deflate(this.printContents)
      )
      let routeData = this.$router.resolve({ name: 'printHtml', query: { data: this.reportLinkData } })
      window.open(routeData.href, '_blank')
      // window.print()
    },
    async fetch () {
      try {
        this.inAction = true
        this.totalBanks = 0
        this.reports = []
        this.dayInAction = 'Запуск'
        await asyncTimeout(500)
        if (moment(this.end).isBefore(moment(this.start))) {
          const e = new Error('Старт должен быть перед финишем')
          this.$store.dispatch('snack', e)
          throw e
        }
        this.report = []
        await this.fetchReports()
      } catch (e) {
        this.$store.dispatch('snack', e)
        this.report = null
      } finally {
        this.inAction = false
        this.dayInAction = null
      }
    },
    async fetchReports () {
      for (let day = this.end; moment(this.start).isBefore(day) || this.start === day; day = moment(day).subtract(1, 'day').format('YYYY-MM-DD')) {
        if (this.stopNext === true) {
          const e = new Error('Остановлено пользователем')
          this.$store.dispatch('snack', e)
          throw e
        }
        this.dayInAction = day
        await this.addReport(await this.fetchReport(day))
      }
    },
    async fetchReport (day) {
      this.inAction = true
      try {
        const { report } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-report',
          pl: {
            day
          }
        })
        return report
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.inAction = false
        this.stopNext = false
      }
    },
    async fetchMessagesReport () {
      try {
        const { start, end } = this
        const { report } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-messages-report',
          pl: { start, end }
        })
        this.messagesReport = report
        return report
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchSubsReport () {
      try {
        this.subsReport = []
        const { start, end } = this
        const { report } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-subs-report',
          pl: { start, end }
        })
        this.subsReport = report
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async addReport (report) {
      this.reports.push(report)
      report.orgs.forEach(org => {
        const orgidx = this.report.findIndex(x => org.orgid === x.orgid)
        if (orgidx === -1) {
          org.activities = org.activities.map(x => {
            x.sum = x.purposes.reduce((r, y) => r + parseInt(y.sum), 0)
            if (x.activitytypeid === 'bank') {
              this.totalBanks += parseInt(x.sum)
            }
            return x
          })
          this.report.push(org)
        } else {
          org.activities.forEach(act => {
            const actidx = this.report[orgidx].activities.findIndex(x => act.activityid === x.activityid)
            if (actidx === -1) {
              act['sum'] = 0
              this.report[orgidx].activities.push(act)
            } else {
              act.purposes.forEach(pur => {
                this.report[orgidx].activities[actidx].sum += parseInt(pur.sum)
                if (act.activitytypeid === 'bank') {
                  this.totalBanks += parseInt(pur.sum)
                }
                const puridx = this.report[orgidx].activities[actidx].purposes.findIndex(x => pur.purposeid === x.purposeid)
                if (puridx === -1) {
                  this.report[orgidx].activities[actidx].purposes.push(pur)
                } else {
                  this.report[orgidx].activities[actidx].purposes[puridx].sum += parseInt(pur.sum)
                }
              })
            }
          })
        }
      })
    },
    deobjectivate (obj) {
      return Object.keys(obj).map(x => obj[x])
    },
    rubles (kops) {
      return (parseFloat(kops) / 100).toFixed(2)
    },
    migrationHidden (org) {
      return org.orgid === 'migration' && moment(this.start).isAfter(moment('2019-08-24'))
    },
  },
  computed: {
    reportOrdered () {
      return (this.report || [] ).sort(this.showorder)
    }
  },
  watch: {
    start () {
      this.totalBanks = 0
      this.reports = []
      this.report = null
    },
    end () {
      this.totalBanks = 0
      this.reports = []
      this.report = null
    }
  }
}
</script>

<style lang="css">
  @media print {
    .hide-on-print {
      display: none
    }
  }
</style>
